import React, { useCallback, useEffect, useState } from "react";
import AddTreatmentOne from "./components/AddTreatmentOne";
import baseUrl from "../../../../api/baseUrl";
import { useDispatch } from "react-redux";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AddIcon from "@mui/icons-material/Add";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PercentIcon from "@mui/icons-material/Percent";
import {
  setloadeActive,
  setloadeDeactive,
} from "../../../../redux/loader/loaderActions";

function TreatmentAllList() {
  const [tretmentOpen, settretmentOpen] = useState(false);
  const [data, setData] = useState([]);
  const [dentists, setDentists] = useState<any[]>([]);
  const dispatch = useDispatch();
  const [type, setType] = useState({});

  const getdata = useCallback(() => {
    dispatch(setloadeActive());
    baseUrl
      .get("alltreatment/findAllTreatment")
      .then((response) => {
        dispatch(setloadeDeactive());
        setData(response.data.data);
      })
      .catch((error) => {
        dispatch(setloadeDeactive());
        console.log(error);
      });
  }, [dispatch]);

  useEffect(() => {
    getdata();
  }, [tretmentOpen, getdata]);

  useEffect(() => {
    baseUrl
      .get("appointment/findAllAppointmentDentist")
      .then((res) => setDentists(res.data.data || []))
      .catch(() => setDentists([]));
  }, []);

  const getDentistName = (id: string) => {
    const d = dentists.find((x: any) => String(x._id) === String(id));
    return d ? `${d.title || d.firstName || ""} ${d.lastName || ""}`.trim() || id : id;
  };

  const formatCommissionDisplay = (defaultCommission: number, overrides: any[] = []) => {
    const def = `${defaultCommission ?? 0}%`;
    if (!overrides || overrides.length === 0) return def;
    const parts = overrides.map((o: any) => `${getDentistName(o.dentistId?.toString?.() || o.dentistId)}: ${o.commission ?? 0}%`);
    return `${def} (default), ${parts.join(", ")}`;
  };

  const openModel = () => {
    settretmentOpen(!tretmentOpen);
    setType({});
  };

  const deactivateTreatment = (e: any) => {
    baseUrl
      .post("alltreatment/updateTreatmentStatus", e, { headers: { status: "false" } })
      .then((response) => getdata())
      .catch((error) => console.log(error));
  };

  const handleEdit = (e: any) => {
    settretmentOpen(!tretmentOpen);
    setType(e);
  };

  // Flatten data for display
  const flattenedData: any[] = [];
  data
    ?.filter((item: any) => item.status1 === true)
    ?.forEach((item: any) => {
      // Always show a row for the main treatment first
      flattenedData.push({
        level: "main",
        treatment: item?.treatment,
        type: "",
        subType: "",
        price: item?.price,
        materialCost: item?.materialCost,
        doctorCommission: item?.doctorCommission,
        doctorCommissionOverrides: item?.doctorCommissionOverrides || [],
        editData: {
          type: "main",
          treatmentid: item?._id,
          treatment: item?.treatment,
          price: item?.price,
          materialCost: item?.materialCost,
          doctorCommission: item?.doctorCommission,
          doctorCommissionOverrides: item?.doctorCommissionOverrides || [],
        },
        deactivateData: {
          type: "main",
          mainId: item?._id,
        },
      });

      // Then show its types and subtypes as subsequent rows
      if (item?.type?.length > 0) {
        item?.type
          ?.filter((t: any) => t.status2 === true)
          ?.forEach((typeItem: any) => {
            flattenedData.push({
              level: "type",
              treatment: item?.treatment,
              type: typeItem?.treatment,
              subType: "",
              price: typeItem?.price,
              materialCost: typeItem?.materialCost,
              doctorCommission: typeItem?.doctorCommission,
              doctorCommissionOverrides: typeItem?.doctorCommissionOverrides || [],
              editData: {
                type: "sub",
                treatmentid: item?._id,
                subId: typeItem?._id,
                treatment: typeItem?.treatment,
                price: typeItem?.price,
                materialCost: typeItem?.materialCost,
                doctorCommission: typeItem?.doctorCommission,
                doctorCommissionOverrides: typeItem?.doctorCommissionOverrides || [],
              },
              deactivateData: {
                type: "sub",
                mainId: item?._id,
                subId: typeItem?._id,
              },
            });

            if (typeItem?.subType?.length > 0) {
              typeItem?.subType
                ?.filter((s: any) => s.status3 === true)
                ?.forEach((subtype: any) => {
                  flattenedData.push({
                    level: "subtype",
                    treatment: item?.treatment,
                    type: typeItem?.treatment,
                    subType: subtype?.treatment,
                    price: subtype?.price,
                    materialCost: subtype?.materialCost,
                    doctorCommission: subtype?.doctorCommission,
                    doctorCommissionOverrides: subtype?.doctorCommissionOverrides || [],
                    editData: {
                      type: "subsub",
                      treatmentid: item?._id,
                      subId: typeItem?._id,
                      subsubId: subtype?._id,
                      treatment: subtype?.treatment,
                      price: subtype?.price,
                      materialCost: subtype?.materialCost,
                      doctorCommission: subtype?.doctorCommission,
                      doctorCommissionOverrides: subtype?.doctorCommissionOverrides || [],
                    },
                    deactivateData: {
                      type: "subsub",
                      mainId: item?._id,
                      subId: typeItem?._id,
                      subsubId: subtype?._id,
                    },
                  });
                });
            }
          });
      }
    });

  return (
    <>
      {/* Header Card */}
      <div className="bg-white dark:bg-slate-800 rounded-xl shadow-md shadow-slate-200/50 dark:shadow-slate-900/50 border border-slate-100 dark:border-slate-700 p-3 mb-3">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-gradient-to-br from-primary to-primaryLight rounded-lg flex items-center justify-center">
              <MedicalServicesIcon className="text-white" sx={{ fontSize: 18 }} />
            </div>
            <div>
              <h3 className="text-base font-bold text-slate-800 dark:text-slate-200">Treatment List</h3>
              <p className="text-xs text-slate-500 dark:text-slate-400">{flattenedData.length} treatments</p>
            </div>
          </div>
          <button
            onClick={() => openModel()}
            className="flex items-center gap-1.5 px-3 py-2 text-sm bg-gradient-to-r from-primary to-primaryLight text-white rounded-lg hover:shadow-md hover:shadow-primary/20 transition-all font-medium"
          >
            <AddIcon sx={{ fontSize: 18 }} />
            ADD
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white dark:bg-slate-800 rounded-xl shadow-md shadow-slate-200/50 dark:shadow-slate-900/50 border border-slate-100 dark:border-slate-700 overflow-hidden">
        {/* Mobile Cards */}
        <div className="md:hidden p-3 space-y-2">
          {flattenedData.length === 0 ? (
            <div className="text-center py-8 text-slate-400 dark:text-slate-500">
              <MedicalServicesIcon sx={{ fontSize: 36 }} className="mb-1" />
              <p className="text-sm">No treatments found</p>
            </div>
          ) : (
            flattenedData.map((item: any, i: number) => (
              <div key={i} className="bg-slate-50 dark:bg-slate-700/50 rounded-lg p-3 border border-slate-100 dark:border-slate-600">
                <div className="mb-2">
                  <p className="text-sm font-semibold text-slate-800 dark:text-slate-200">
                    <span className={item.level === "type" ? "pl-3 inline-block" : item.level === "subtype" ? "pl-6 inline-block" : ""}>
                      {item.treatment}
                    </span>
                  </p>
                  {item.type && (
                    <p className={`text-xs text-indigo-600 dark:text-indigo-400 ${item.level === "subtype" ? "pl-6" : item.level === "type" ? "pl-3" : ""}`}>{item.type}</p>
                  )}
                  {item.subType && (
                    <p className={`text-xs text-slate-500 dark:text-slate-400 ${item.level === "subtype" ? "pl-6" : ""}`}>{item.subType}</p>
                  )}
                </div>
                <div className="grid grid-cols-3 gap-1.5 mb-2">
                  <div className="bg-white dark:bg-slate-800 rounded-lg p-1.5 text-center">
                    <p className="text-[10px] text-slate-500 dark:text-slate-400">Price</p>
                    <p className="text-sm font-semibold text-emerald-600 dark:text-emerald-400">
                      {item.treatment === "Others" && (item.price === 0 || item.price == null) ? "Dynamic" : item.price}
                    </p>
                  </div>
                  <div className="bg-white dark:bg-slate-800 rounded-lg p-1.5 text-center">
                    <p className="text-[10px] text-slate-500 dark:text-slate-400">Cost</p>
                    <p className="text-sm font-semibold text-slate-700 dark:text-slate-300">{item.materialCost || 0}</p>
                  </div>
                  <div className="bg-white dark:bg-slate-800 rounded-lg p-1.5 text-center">
                    <p className="text-[10px] text-slate-500 dark:text-slate-400">Comm %</p>
                    <p className="text-xs font-semibold text-blue-600 dark:text-blue-400" title={formatCommissionDisplay(item.doctorCommission, item.doctorCommissionOverrides)}>
                      {item.doctorCommissionOverrides?.length ? formatCommissionDisplay(item.doctorCommission, item.doctorCommissionOverrides) : `${item.doctorCommission || 0}%`}
                    </p>
                  </div>
                </div>
                <div className="flex gap-1.5 pt-2 border-t border-slate-200 dark:border-slate-600">
                  <button
                    onClick={() => handleEdit(item.editData)}
                    className="flex-1 flex items-center justify-center gap-1 px-2 py-1.5 text-xs bg-indigo-50 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-400 rounded-lg hover:bg-indigo-100 dark:hover:bg-indigo-800/50 transition-colors font-medium"
                  >
                    <BorderColorIcon sx={{ fontSize: 16 }} />
                    Edit
                  </button>
                  {item.treatment !== "Others" && (
                  <button
                    onClick={() => deactivateTreatment(item.deactivateData)}
                    className="p-1.5 bg-red-50 dark:bg-red-900/40 text-red-500 dark:text-red-400 rounded-lg hover:bg-red-100 dark:hover:bg-red-800/50 transition-colors"
                  >
                    <DeleteOutlineIcon sx={{ fontSize: 16 }} />
                  </button>
                  )}
                </div>
              </div>
            ))
          )}
        </div>

        {/* Desktop Table */}
        <div className="hidden md:block overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-slate-50/80 dark:bg-slate-700/50">
                <th className="px-4 py-2 text-left text-[10px] font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                  Treatment
                </th>
                <th className="px-4 py-2 text-left text-[10px] font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                  Type
                </th>
                <th className="px-4 py-2 text-left text-[10px] font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                  Sub Type
                </th>
                <th className="px-4 py-2 text-left text-[10px] font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                  <div className="flex items-center gap-1">
                    <AttachMoneyIcon sx={{ fontSize: 14 }} />
                    Price
                  </div>
                </th>
                <th className="px-4 py-2 text-left text-[10px] font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                  Cost
                </th>
                <th className="px-4 py-2 text-left text-[10px] font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                  <div className="flex items-center gap-1">
                    <PercentIcon sx={{ fontSize: 12 }} />
                    Commission
                  </div>
                </th>
                <th className="px-4 py-2 text-right text-[10px] font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100 dark:divide-slate-700">
              {flattenedData.length === 0 ? (
                <tr>
                  <td colSpan={7} className="px-4 py-8 text-center text-slate-400 dark:text-slate-500 text-sm">
                    <MedicalServicesIcon sx={{ fontSize: 36 }} className="mb-1" />
                    <p>No treatments found</p>
                  </td>
                </tr>
              ) : (
                flattenedData.map((item: any, i: number) => (
                  <tr key={i} className="hover:bg-slate-50/50 dark:hover:bg-slate-700/50 transition-colors">
                    <td className="px-4 py-2">
                      <span className={`font-medium text-slate-800 dark:text-slate-200 ${item.level === "type" ? "pl-3 inline-block" : item.level === "subtype" ? "pl-6 inline-block" : ""}`}>{item.treatment}</span>
                    </td>
                    <td className="px-4 py-2">
                      {item.type ? (
                        <span className="px-2 py-0.5 bg-indigo-50 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-400 rounded-full text-xs font-medium">
                          {item.type}
                        </span>
                      ) : (
                        <span className="text-slate-400 dark:text-slate-500">-</span>
                      )}
                    </td>
                    <td className="px-4 py-2">
                      {item.subType ? (
                        <span className="px-2 py-0.5 bg-purple-50 dark:bg-purple-900/40 text-purple-600 dark:text-purple-400 rounded-full text-xs font-medium">
                          {item.subType}
                        </span>
                      ) : (
                        <span className="text-slate-400 dark:text-slate-500">-</span>
                      )}
                    </td>
                    <td className="px-4 py-2">
                      <span className="font-semibold text-emerald-600 dark:text-emerald-400">
                        {item.treatment === "Others" && (item.price === 0 || item.price == null) ? "Dynamic" : item.price}
                      </span>
                    </td>
                    <td className="px-4 py-2 text-slate-600 dark:text-slate-400">
                      {item.materialCost || 0}
                    </td>
                    <td className="px-4 py-2">
                      <span className="px-2 py-0.5 bg-blue-50 dark:bg-blue-900/40 text-blue-600 dark:text-blue-400 rounded-full text-xs font-medium max-w-[200px] block truncate" title={formatCommissionDisplay(item.doctorCommission, item.doctorCommissionOverrides)}>
                        {item.doctorCommissionOverrides?.length ? formatCommissionDisplay(item.doctorCommission, item.doctorCommissionOverrides) : `${item.doctorCommission || 0}%`}
                      </span>
                    </td>
                    <td className="px-4 py-2 text-right">
                      <div className="flex items-center justify-end gap-1.5">
                        <button
                          onClick={() => handleEdit(item.editData)}
                          className="p-1.5 rounded-lg bg-indigo-50 dark:bg-indigo-900/40 text-indigo-600 dark:text-indigo-400 hover:bg-indigo-100 dark:hover:bg-indigo-800/50 transition-colors"
                          title="Edit"
                        >
                          <BorderColorIcon sx={{ fontSize: 16 }} />
                        </button>
                        {item.treatment !== "Others" && (
                        <button
                          onClick={() => deactivateTreatment(item.deactivateData)}
                          className="p-1.5 rounded-lg bg-red-50 dark:bg-red-900/40 text-red-500 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-800/50 transition-colors"
                          title="Deactivate"
                        >
                          <DeleteOutlineIcon sx={{ fontSize: 16 }} />
                        </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {tretmentOpen && <AddTreatmentOne type={type} close={settretmentOpen} />}
    </>
  );
}

export default TreatmentAllList;
